import Marquee from "react-fast-marquee";
import { useInView } from "react-intersection-observer";
import Alef from "../../assets/images/alef.png";
import AydindoganVakfi from "../../assets/images/aydindogan-vakfi.png";
import Binyaprak from "../../assets/images/binyaprak.png";
import BogaziciUniversitesi from "../../assets/images/bogazici-universitesi.png";
import Budyboo from "../../assets/images/budyboo.png";
import Cesme from "../../assets/images/cesme.png";
import Citio from "../../assets/images/citio.png";
import ColendiB2B from "../../assets/images/colendi-b2b.png";
import Colendi from "../../assets/images/colendi.png";
import ColendiBank from "../../assets/images/colendibank.png";
import Coven from "../../assets/images/coven.png";
import Culture from "../../assets/images/culture.png";
import CuriousGremlin from "../../assets/images/curious-gremlin.png";
import CVentures from "../../assets/images/cventures.png";
import Dessera from "../../assets/images/dessera.png";
import Dzd from "../../assets/images/dzd.png";
import Erkek from "../../assets/images/erkek.png";
import EStar from "../../assets/images/estar.png";
import ForbesZirve from "../../assets/images/forbes-zirve.png";
import Forbes from "../../assets/images/forbes.png";
import Guvensan from "../../assets/images/guvensan.png";
import Ibrahim from "../../assets/images/ibrahim.png";
import Ic from "../../assets/images/ic.png";
import Kadin from "../../assets/images/kadin.png";
import Kolektif from "../../assets/images/kolektif.png";
import Looyti from "../../assets/images/looyti.png";
import MadamecocoPrestige from "../../assets/images/madamecoco-prestige.svg";
import May from "../../assets/images/may.png";
import Menkul from "../../assets/images/menkul.png";
import Meral from "../../assets/images/meral.png";
import Molecure from "../../assets/images/molecure.png";
import MoneypayTeknoloji from "../../assets/images/moneypay-teknoloji.png";
import Moneypay from "../../assets/images/moneypay.png";
import NefArsa from "../../assets/images/nef-arsa.png";
import No44 from "../../assets/images/no44.png";
import Ofmark from "../../assets/images/ofmark.png";
import Ogansia from "../../assets/images/ogansia.png";
import Pala from "../../assets/images/pala.png";
import Piks from "../../assets/images/piks.png";
import Pirix from "../../assets/images/pirix.png";
import Pofft from "../../assets/images/pofft.png";
import Rna from "../../assets/images/rna.png";
import Sakli from "../../assets/images/sakli.png";
import Sebnem from "../../assets/images/sebnem.png";
import Sigorta from "../../assets/images/sigorta.png";
import Startupfon from "../../assets/images/startupfon.png";
import Ted from "../../assets/images/ted.png";
import TRWin from "../../assets/images/trwin.png";
import Tutumlu from "../../assets/images/tutumlu.png";
import XSights from "../../assets/images/xsights.png";
import Yeniden from "../../assets/images/yeniden.png";
import YTech from "../../assets/images/ytech.png";
import YVentures from "../../assets/images/yventures.png";
import "./References.scss";

const References = () => {
  const sections = useInView({ threshold: 0.2, triggerOnce: true });
  const sections2 = useInView({ threshold: 0.6, triggerOnce: true });
  const sections3 = useInView({ threshold: 0.7, triggerOnce: true });

  return (
    <section className="references">
      <div ref={sections.ref} className="ref-screen">
        <span className="left justify-self-start">REFERENCES</span>
        <div className="relative xl:self-end xl:mt-[80px] overflow-hidden w-full">
          <div className="flex flex-col xl:flex-row xl:justify-center">
            <span
              className={`title ${
                sections.inView ? "fade-in-left" : "fade-out"
              }`}
            >
              we love&nbsp;
            </span>
            <span
              className={`title ${
                sections.inView ? "delay-1-5s fade-in-up" : "fade-out"
              }`}
            >
              to leave a mark
            </span>
          </div>
          <Marquee
            className={`flex xl:!hidden ${
              sections.inView ? "delay-3s fade-in" : "fade-out"
            }`}
            autoFill
            speed={30}
          >
            <div className="flex gap-10 mt-10 justify-center mr-10 h-[50px]">
              <img style={{ height: "50px" }} src={YVentures} alt="YVentures" />
              <img style={{ height: "50px" }} src={YTech} alt="YTech" />
              <img style={{ height: "50px" }} src={XSights} alt="XSights" />
              <img
                style={{ height: "47px" }}
                src={ColendiB2B}
                alt="Colendi B2B"
              />
            </div>
          </Marquee>
          <Marquee
            className={`flex xl:!hidden ${
              sections.inView ? "delay-3s fade-in" : "fade-out"
            }`}
            autoFill
            direction="right"
            speed={30}
          >
            <div className="flex gap-10 mt-10 justify-center mr-10 h-[60px]">
              <img
                style={{ height: "60px" }}
                src={AydindoganVakfi}
                alt="Aydın Doğan Vakfı"
              />
              <img
                style={{ height: "60px" }}
                src={BogaziciUniversitesi}
                alt="Boğaziçi Üniversitesi"
              />
              <img
                style={{ height: "60px" }}
                src={CuriousGremlin}
                alt="Curious Gremlin"
              />
              <img
                style={{ height: "60px" }}
                src={ForbesZirve}
                alt="Mobilitenin Geleceği Zirvesi 2025 Forbes"
              />
              <img style={{ height: "42px" }} src={EStar} alt="EStar" />
              <img style={{ height: "60px" }} src={Citio} alt="Citio" />
              <img style={{ height: "60px" }} src={Dzd} alt="Dzd" />
              <img style={{ height: "56px" }} src={Looyti} alt="Looyti" />
            </div>
          </Marquee>
          <Marquee
            className={`flex xl:!hidden ${
              sections.inView ? "delay-3s fade-in" : "fade-out"
            }`}
            autoFill
            speed={30}
          >
            <div className="flex gap-10 mt-5 justify-center mr-10 h-[90px]">
              <img style={{ height: "52px" }} src={Sigorta} alt="Sigorta" />
              <img
                style={{ height: "96px", margin: "-13px" }}
                src={Yeniden}
                alt="Yeniden"
              />
              <img
                style={{ height: "90px", margin: "-10px 0" }}
                src={Kadin}
                alt="Kadin"
              />
              <img style={{ height: "60px" }} src={Dessera} alt="Dessera" />
              <img style={{ height: "34px" }} src={Colendi} alt="Colendi" />
              <img
                style={{ height: "30px" }}
                src={ColendiBank}
                alt="ColendiBank"
              />
            </div>
          </Marquee>
          <Marquee
            className={`flex xl:!hidden ${
              sections.inView ? "delay-3s fade-in" : "fade-out"
            }`}
            autoFill
            direction="right"
            speed={30}
          >
            <div className="flex gap-10 mt-5 justify-center mr-10 h-[70px]">
              <img
                style={{ height: "60px" }}
                src={MoneypayTeknoloji}
                alt="Moneypay Teknoloji"
              />
              <img
                style={{ height: "60px" }}
                src={Startupfon}
                alt="Startupfon"
              />
              <img style={{ height: "52px" }} src={Moneypay} alt="Moneypay" />
              <img style={{ height: "48px" }} src={Rna} alt="rna" />
              <img
                style={{ height: "48px" }}
                src={MadamecocoPrestige}
                alt="Madamecoco Prestige"
              />
              <img
                style={{ height: "80px", margin: "-10px" }}
                src={Binyaprak}
                alt="Binyaprak"
              />
            </div>
          </Marquee>
          <Marquee
            className={`flex xl:!hidden ${
              sections.inView ? "delay-3s fade-in" : "fade-out"
            }`}
            autoFill
            speed={30}
          >
            <div className="flex gap-10 mt-5 justify-center mr-10 h-[60px]">
              <img style={{ height: "40px" }} src={TRWin} alt="TRWin" />
              <img
                style={{ height: "70px", margin: "-5px 0" }}
                src={Ic}
                alt="Ic"
              />
              <img style={{ height: "45px" }} src={NefArsa} alt="Nef Arsa" />
              <img style={{ height: "60px" }} src={Cesme} alt="Cesme" />
              <img style={{ height: "47px" }} src={Menkul} alt="Menkul" />
              <img style={{ height: "50px" }} src={Forbes} alt="Forbes" />
            </div>
          </Marquee>
        </div>

        <div
          className={`hidden ref-slide xl:flex gap-4 mt-[60px] justify-center self-start ${
            sections.inView ? "delay-3s fade-in" : "fade-out"
          }`}
        >
          <img style={{ height: "50px" }} src={YVentures} alt="YVentures" />
          <div className="slide-div" />
          <img style={{ height: "50px" }} src={YTech} alt="YTech" />
          <div className="slide-div" />
          <img style={{ height: "50px" }} src={XSights} alt="XSights" />
          <div className="slide-div" />
          <img style={{ height: "47px" }} src={ColendiB2B} alt="Colendi B2B" />
        </div>
        <div
          className={`hidden ref-slide xl:flex gap-4 mt-[60px] justify-center self-start ${
            sections.inView ? "delay-3s fade-in" : "fade-out"
          }`}
        >
          <img
            style={{ height: "60px" }}
            src={AydindoganVakfi}
            alt="Aydın Doğan Vakfı"
          />
          <div className="slide-div" />
          <img
            style={{ height: "60px" }}
            src={BogaziciUniversitesi}
            alt="Boğaziçi Üniversitesi"
          />
          <img
            style={{ height: "60px" }}
            src={CuriousGremlin}
            alt="Curious Gremlin"
          />
          <div className="slide-div" />
          <img
            style={{ height: "60px" }}
            src={ForbesZirve}
            alt="Mobilitenin Geleceği Zirvesi 2025 Forbes"
          />
          <div className="slide-div" />
          <img style={{ height: "42px" }} src={EStar} alt="EStar" />
          <div className="slide-div" />
          <img style={{ height: "60px" }} src={Citio} alt="Citio" />
          <div className="slide-div" />
          <img style={{ height: "60px" }} src={Dzd} alt="Dzd" />
          <div className="slide-div" />
          <img style={{ height: "56px" }} src={Looyti} alt="Looyti" />
        </div>
        <div
          className={`hidden ref-slide xl:flex gap-4 mt-[60px] justify-center self-start ${
            sections.inView ? "delay-3s fade-in" : "fade-out"
          }`}
        >
          <img style={{ height: "52px" }} src={Sigorta} alt="Sigorta" />
          <div className="slide-div" />
          <img
            style={{ height: "96px", margin: "-13px" }}
            src={Yeniden}
            alt="Yeniden"
          />
          <div className="slide-div" />
          <img
            style={{ height: "90px", margin: "-10px 0" }}
            src={Kadin}
            alt="Kadin"
          />
          <div className="slide-div" />
          <img style={{ height: "60px" }} src={Dessera} alt="Dessera" />
          <div className="slide-div" />
          <img style={{ height: "34px" }} src={Colendi} alt="Colendi" />
          <div className="slide-div" />
          <img style={{ height: "30px" }} src={ColendiBank} alt="ColendiBank" />
        </div>
        <div
          className={`hidden ref-slide xl:flex gap-4 mt-[60px] justify-center self-start ${
            sections.inView ? "delay-3s fade-in" : "fade-out"
          }`}
        >
          <img
            style={{ height: "60px" }}
            src={MoneypayTeknoloji}
            alt="Moneypay Teknoloji"
          />
          <div className="slide-div" />

          <img style={{ height: "60px" }} src={Startupfon} alt="Startupfon" />
          <div className="slide-div" />

          <img style={{ height: "52px" }} src={Moneypay} alt="Moneypay" />
          <div className="slide-div" />

          <img style={{ height: "48px" }} src={Rna} alt="rna" />
          <div className="slide-div" />
          <img
            style={{ height: "40px" }}
            src={MadamecocoPrestige}
            alt="Madamecoco Prestige"
          />

          <div className="slide-div" />
          <img
            style={{ height: "80px", margin: "-10px" }}
            src={Binyaprak}
            alt="Binyaprak"
          />
        </div>
        <div
          className={`hidden ref-slide xl:flex gap-4 mt-[60px] justify-center self-start ${
            sections.inView ? "delay-3s fade-in" : "fade-out"
          }`}
        >
          <img style={{ height: "40px" }} src={TRWin} alt="TRWin" />
          <div className="slide-div" />
          <img style={{ height: "70px", margin: "-5px 0" }} src={Ic} alt="Ic" />
          <div className="slide-div" />
          <img style={{ height: "45px" }} src={NefArsa} alt="Nef Arsa" />
          <div className="slide-div" />
          <img style={{ height: "60px" }} src={Cesme} alt="Cesme" />
          <div className="slide-div" />
          <img style={{ height: "47px" }} src={Menkul} alt="Menkul" />
          <div className="slide-div" />
          <img style={{ height: "50px" }} src={Forbes} alt="Forbes" />
        </div>
      </div>
      <div ref={sections2.ref} className="ref-screen">
        <div className="relative xl:self-end overflow-hidden w-full">
          <div className="flex flex-col xl:flex-row xl:justify-center">
            <span
              className={`title ${
                sections2.inView ? "fade-in-up" : "fade-out"
              }`}
            >
              always a part of&nbsp;
            </span>
            <div className="flex self-center">
              <span
                className={`title ${
                  sections2.inView ? "fade-in-up" : "fade-out"
                }`}
              >
                our
              </span>
              <span
                className={`title ${
                  sections2.inView ? "fade-in-up" : "fade-out"
                }`}
              >
                &nbsp;legacy
              </span>
            </div>
          </div>
          <Marquee
            className={`flex xl:!hidden ${
              sections2.inView ? "delay-1-5s fade-in" : "fade-out"
            }`}
            autoFill
            speed={30}
          >
            <div className="flex gap-10 mt-10 justify-center mr-10 h-12 grayscale">
              <img src={Sebnem} alt="Sebnem" />
              <img src={Alef} alt="Alef" />
              <img src={Tutumlu} alt="Tutumlu" />
              <img src={Pala} alt="Pala" />
            </div>
          </Marquee>
          <Marquee
            className={`flex xl:!hidden ${
              sections2.inView ? "delay-1-5s fade-in" : "fade-out"
            }`}
            direction="right"
            autoFill
            speed={30}
          >
            <div className="flex gap-10 mt-5 justify-center mr-10 h-12 grayscale">
              <img src={Piks} alt="Piks" />
              <img src={Ted} alt="Ted" />
              <img src={Culture} alt="Culture" />
              <img src={Erkek} alt="Erkek" />
            </div>
          </Marquee>
          <Marquee
            className={`flex xl:!hidden ${
              sections2.inView ? "delay-1-5s fade-in" : "fade-out"
            }`}
            autoFill
            speed={30}
          >
            <div className="flex gap-10 mt-5 justify-center mr-10 h-12 grayscale">
              <img src={Guvensan} alt="Guvensan" />
              <img src={Ibrahim} alt="Ibrahim" />
              <img src={Sakli} alt="Sakli" />
              <img src={Kolektif} alt="Kolektif" />
              <img src={Molecure} alt="Molecure" />
            </div>
          </Marquee>
          <Marquee
            className={`flex xl:!hidden ${
              sections2.inView ? "delay-1-5s fade-in" : "fade-out"
            }`}
            direction="right"
            autoFill
            speed={30}
          >
            <div className="flex gap-10 mt-5 justify-center mr-10 h-12 grayscale">
              <img src={Meral} alt="Meral" />
              <img src={No44} alt="No44" />
              <img src={Ofmark} alt="Ofmark" />
              <img src={Ogansia} alt="Ogansia" />
              <img src={May} alt="May" />
              <img src={Rna} alt="Rna" />
            </div>
          </Marquee>
        </div>
        <div
          className={`hidden ref-slide xl:flex gap-4 mt-[120px] justify-center self-start ${
            sections2.inView ? "delay-1-5s fade-in-up-lum" : "fade-out"
          } `}
        >
          <img className="mix-blend-luminosity" src={Sebnem} alt="Sebnem" />
          <div className="slide-div" />
          <img className="mix-blend-luminosity" src={Alef} alt="Alef" />
          <div className="slide-div" />
          <img className="mix-blend-luminosity" src={Tutumlu} alt="Tutumlu" />
          <div className="slide-div" />
          <img className="mix-blend-luminosity" src={Pala} alt="Pala" />
          <div className="slide-div" />
          <img className="mix-blend-luminosity" src={Rna} alt="Rna" />
        </div>
        <div
          className={`hidden ref-slide xl:flex gap-4 mt-[50px] justify-center self-start ${
            sections2.inView ? "delay-1-5s fade-in-up-lum" : "fade-out"
          } `}
        >
          <img className="mix-blend-luminosity" src={Piks} alt="Piks" />
          <div className="slide-div" />
          <img className="mix-blend-luminosity" src={Ted} alt="Ted" />
          <div className="slide-div" />
          <img className="mix-blend-luminosity" src={Culture} alt="Culture" />
          <div className="slide-div" />
          <img className="mix-blend-luminosity" src={Erkek} alt="Erkek" />
          <div className="slide-div" />
          <img className="mix-blend-luminosity" src={Molecure} alt="Molecure" />
        </div>
        <div
          className={`hidden ref-slide xl:flex gap-4 mt-[50px] justify-center self-start ${
            sections2.inView ? "delay-1-5s fade-in-up-lum" : "fade-out"
          } `}
        >
          <img className="mix-blend-luminosity" src={Guvensan} alt="Guvensan" />
          <div className="slide-div" />
          <img className="mix-blend-luminosity" src={Ibrahim} alt="Ibrahim" />
          <div className="slide-div" />
          <img className="mix-blend-luminosity" src={Sakli} alt="Sakli" />
          <div className="slide-div" />
          <img className="mix-blend-luminosity" src={Kolektif} alt="Kolektif" />
          <div className="slide-div" />
          <img className="mix-blend-luminosity" src={Meral} alt="Meral" />
        </div>
        <div
          className={`hidden ref-slide xl:flex gap-4 mt-[50px] justify-center self-start ${
            sections2.inView ? "delay-1-5s fade-in-up-lum" : "fade-out"
          } `}
        >
          <img className="mix-blend-luminosity" src={No44} alt="No44" />
          <div className="slide-div" />
          <img className="mix-blend-luminosity" src={Ofmark} alt="Ofmark" />
          <div className="slide-div" />
          <img className="mix-blend-luminosity" src={Ogansia} alt="Ogansia" />
          <div className="slide-div" />
          <img className="mix-blend-luminosity" src={May} alt="May" />
        </div>
      </div>
      <div id="partners" ref={sections3.ref} className="ref-screen">
        <span className="left justify-self-start">PARTNERS</span>
        <div className="relative xl:self-end xl:mt-[80px] overflow-hidden w-full">
          <div className="flex flex-col xl:flex-row xl:justify-center">
            <span
              className={`title ${
                sections3.inView ? "fade-in-up" : "fade-out"
              }`}
            >
              united, we empower excellence
            </span>
          </div>
          <Marquee
            className={`flex xl:!hidden ${
              sections3.inView ? "delay-1-5s fade-in" : "fade-out"
            }`}
            autoFill
            speed={30}
          >
            <div className="flex gap-10 mt-10 justify-center mr-10 h-12 h-">
              <img src={Budyboo} alt="Budyboo" />
              <img src={Looyti} alt="Looyti" />
              <img src={Pirix} alt="Pirix" />
              <img src={Pofft} alt="Pofft" />
              <img src={Coven} alt="Coven" />
            </div>
          </Marquee>
          <Marquee
            className={`flex xl:!hidden ${
              sections3.inView ? "delay-1-5s fade-in" : "fade-out"
            }`}
            direction="right"
            autoFill
            speed={30}
          >
            <div className="flex gap-10 mt-5 justify-center mr-10 h-12">
              <img src={CVentures} alt="CVentures" />
              <img src={Colendi} alt="Colendi" />
            </div>
          </Marquee>
        </div>
        <div
          className={`hidden ref-slide xl:flex gap-4 mt-[120px] justify-center self-start ${
            sections3.inView ? "delay-1-5s fade-in" : "fade-out"
          }`}
        >
          <img src={Budyboo} alt="Budyboo" />
          <div className="slide-div" />
          <img src={Looyti} alt="Looyti" />
          <div className="slide-div" />
          <img src={Pirix} alt="Pirix" />
          <div className="slide-div" />
          <img src={Pofft} alt="Pofft" />
          <div className="slide-div" />
          <img src={Coven} alt="Coven" />
        </div>
        <div
          className={`hidden ref-slide xl:flex gap-4 mt-[50px] justify-center self-start ${
            sections3.inView ? "delay-1-5s fade-in" : "fade-out"
          }`}
        >
          <img src={CVentures} alt="CVentures" />
          <div className="slide-div" />
          <img src={Colendi} alt="Colendi" />
        </div>
      </div>
    </section>
  );
};

export default References;
